import {usePluginEditNodeTextByDoubleClick} from '@/components/MindMap'

export default () => {
    const editNodeTextByDoubleClick = usePluginEditNodeTextByDoubleClick()

    const watchers = {
        async node_double_click({event, node}) {
            event.stopPropagation()
            const {bizNodeType} = node.data

            await this.BizNode[bizNodeType].onDoubleClick(
                this, node, event
            )

            if (! event.defaultPrevented) {
                editNodeTextByDoubleClick.watchers.node_double_click.call(
                    this, {node, event}
                )
            }
        },
    }

    return {watchers}
}
